package org.example.zone360.pages.coachDetails.coachSession

import org.example.zone360.utils.addVideoSession
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.transform
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.FaTriangleExclamation
import com.varabyte.kobweb.silk.components.icons.fa.FaXmark
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import kotlinx.browser.document
import kotlinx.coroutines.launch
import org.example.zone360.components.CommonButton
import org.example.zone360.components.CommonDropdown
import org.example.zone360.components.CustomSpacer
import org.example.zone360.components.OptionalInputField
import org.example.zone360.components.showToast
import org.example.zone360.componentss.FieldTitleTextNormalSimple
import org.example.zone360.pages.coachDetails.charts.CircularProgressIndicator
import org.example.zone360.pages.coachDetails.sessionAllDetails.uploadAudio.uploadAudioChunks
import org.example.zone360.theme.SitePalette
import org.example.zone360.utils.AppGlobal
import org.example.zone360.utils.Res
import org.example.zone360.utils.Strings
import org.example.zone360.utils.ToastID
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.w3c.dom.HTMLInputElement
import org.w3c.files.get

@Composable
fun AddSession(
    coachName: String,
    sitePalette: SitePalette,
    breakpoint: Breakpoint,
    onDialogDismiss: () -> Unit,
    onSave: () -> Unit,
    sessionType: String,
    userId: String,
    toastMessageCall: (String) -> Unit,
    audioSession: Boolean = false,

    ) {
    val scope = rememberCoroutineScope()
    var isLoading by remember { mutableStateOf(false) }
    var sessionNameError by remember { mutableStateOf(false) }
    var selectedSession by remember { mutableStateOf("Training") }
    // Audio upload state
    var isAudioUploading by remember { mutableStateOf(false) }
    var audioUploadProgress by remember { mutableStateOf(0.0) }
    var audioUploadStatus by remember { mutableStateOf("") }

    Box(
        modifier = Modifier
            .width(if (breakpoint < Breakpoint.MD) 400.px else 460.px)
            .position(Position.Fixed)
            .zIndex(999)
            .top(50.percent)
            .left(50.percent)
            .transform { translate((-50).percent, (-50).percent) },
        contentAlignment = Alignment.Center,
    ) {
        Box(
            modifier = Modifier
                .width(90.percent)
                .height(100.percent)
                .onClick { }
        )
        Box(
            modifier = Modifier
                .padding(all = 24.px)
                .width(90.percent)
                .margin(top = 10.px)
                .height(100.percent)
                .backgroundColor(sitePalette.modalBackgroundColor.rgb)
                .border(
                    width = 1.px,
                    color = sitePalette.textFieldBorderColor.rgb,
                    style = LineStyle.Solid
                )
                .borderRadius(4.px),
//                .overflow(Overflow.Auto)
            contentAlignment = Alignment.Center,
        ) {
            Column(modifier = Modifier.fillMaxSize()) {
                Row(
                    horizontalArrangement = Arrangement.SpaceBetween,
                    modifier = Modifier
                        .fillMaxWidth()
                        .margin(bottom = 20.px),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Column {
                        FieldTitleTextNormalSimple(
                            "Add New Session",
                            fontSize = 20.px,
                            fontWeight = 600,
                            onClick = {}
                        )
                    }

                    FaXmark(
                        modifier = Modifier
                            .color(sitePalette.commonButtonSupportiveTextColor.rgb)
                            .cursor(Cursor.Pointer)
                            .onClick { onDialogDismiss() },
                        size = IconSize.LG
                    )

                }

                OptionalInputField(
                    onValueChange = {
                        sessionNameError = false
                    },
                    id = Res.Id.sessionName,
                    width = 100.percent,
                    placeHolder = "Enter Session Name",
                    disallowedKeys = listOf(".", "/", "_")
                )
                if (sessionNameError) {
                    FieldTitleTextNormalSimple(
                        "Please enter session name",
                        fontSize = 12.px,
                        marginTop = 3.px,
                        color = sitePalette.textErrorColor.rgb
                    )
                }
                CustomSpacer(height = 20.px)
                CommonDropdown(
                    height = 42.px,
                    data = Strings.SELECT_SESSION,
                    onSelect = {
                        selectedSession = it
                    },
                    selectedItem = selectedSession,
                    width = 100.percent,
                )
                CustomSpacer(height = 20.px)

                if (audioSession) {
                    if (isAudioUploading) {
                        Row(verticalAlignment = Alignment.CenterVertically) {
                            FaTriangleExclamation(
                                modifier = Modifier.color(sitePalette.primary.rgb)
                            )
                            CustomSpacer(5.px)
                            FieldTitleTextNormalSimple(
                                "Closing this popup will cancel uploading",
                                fontSize = 15.px,
                                fontWeight = 500,
                                color = sitePalette.primary.rgb
                            )
                            CustomSpacer(10.px)
                            CircularProgressIndicator(
                                percentage = audioUploadProgress.toFloat(),
                                size = 40,
                                strokeWidth = 5,
                                fontSize = 10.px,
                                primaryColor = sitePalette.primary.rgb,
                                backgroundColor = Colors.LightGray
                            )
                        }
                    } else {
                        CommonButton(
                            text = "Choose an audio file",
                            icon = {
                                Image(
                                    src = Res.Images.upload_Cloud_Arrow,
                                    modifier = Modifier.size(20.px)
                                )
                            },
                            width = 100.percent,
                            height = 40.px,
                            borderColor = sitePalette.primary.rgb,
                            backgroundColor = Colors.Transparent,
                            textSpanColor = sitePalette.primary.rgb,
                            onCLick = {

                                val sessionNameInput =
                                    (document.getElementById(Res.Id.sessionName) as HTMLInputElement).value
                                if (sessionNameInput.isEmpty()) {
                                    sessionNameError = true
                                    return@CommonButton
                                }


                                val fileInput =
                                    document.createElement("input") as HTMLInputElement
                                fileInput.type = "file"
                                fileInput.accept = "audio/*,audio/aac,.aac"
                                fileInput.onchange = { event ->
                                    val selectedFile =
                                        (event.target as HTMLInputElement).files?.get(
                                            0
                                        )
                                    if (selectedFile != null) {
                                        scope.launch {

                                            isAudioUploading = true
                                            audioUploadProgress = 0.0
                                            uploadAudioChunks(
                                                sessionType = selectedSession.lowercase(),
                                                audioFile = selectedFile,
                                                sessionName = sessionNameInput,
                                                userId = userId,
                                                coachName = coachName,
                                                seasonID = AppGlobal.selectedSeasonId,
                                                organization = AppGlobal.userData.organization,
                                                onProgress = { progress, status ->
                                                    audioUploadProgress =
                                                        progress
                                                    audioUploadStatus =
                                                        status
                                                },
                                                onComplete = { success, result ->
                                                    isAudioUploading = false
                                                    if (success) {
                                                        toastMessageCall("Audio uploaded successfully!")
                                                        showToast(ToastID.SUCCESS)

                                                        onSave()
                                                    } else {
                                                        toastMessageCall("Upload failed: ${result ?: "Unknown error"}")
                                                        showToast(ToastID.ERROR)
                                                    }
                                                }
                                            )
                                        }

                                    }
                                }
                                fileInput.click()
                            }
                        )
                    }
                }

                if (!audioSession) {

                    CommonButton(
                        text = "Save",
                        width = 100.percent,
                        height = 39.px,
                        isLoading = isLoading,
                        onCLick = {
                            scope.launch {
                                val sessionNameInput =
                                    (document.getElementById(Res.Id.sessionName) as HTMLInputElement).value
                                if (sessionNameInput.isEmpty()) {
                                    sessionNameError = true
                                } else {
                                    isLoading = true
                                    try {

                                        val response = addVideoSession(
                                            sessionName = sessionNameInput,
                                            coachName = coachName,
                                            sessionType = selectedSession.lowercase(),
                                            organization = AppGlobal.userData.organization,
                                            domainType = "soccer",
                                            language = "en",
                                            userID = userId
                                        )
                                        if (response.message != null) {
                                            toastMessageCall(response.message)
                                            showToast(ToastID.SUCCESS)
                                            onSave()
                                        } else {
                                            toastMessageCall(response.error!!)
                                            showToast(ToastID.ERROR)
                                        }
                                    } catch (e: Exception) {
                                        toastMessageCall("Failed to add session")
                                        showToast(ToastID.ERROR)
                                    } finally {
                                        isLoading = false
                                    }
                                }
                            }
                        }
                    )
                }
            }
        }
    }
}